

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  DialogTitle,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import EditIcon from "@mui/icons-material/Edit";
import { Paper } from "@mui/material";
import { axiosInstance } from "../../../utility/apiInstance";
import DialogBox from "./OceanDialogBox";
import ModalPopup from "../../../common/ModalPopup";
import SubscriptionForm from "../../oceanComponent/OceanManageSubscription/OceanSubscriptionForm";
import Milestone from "../../oceanComponent/OceanManageSubscription/OceanMileStone";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import chroma from "chroma-js";
import Select, { StylesConfig } from "react-select";
import Loading from "../../../components/AWBDashboard/Loading";
import AddMilestoneGroupingForm from "../../../components/ManageSubscription/AddMilestoneGroupingForm";
import toast from "react-hot-toast";
import { OptionType } from "dayjs";
import AddcustomfieldsForm from "../../../components/AddcustomfieldsForm";
import { useRole } from "../../../components/MangeContextProvide";
import OceanShippingShowModal from "../../../components/AWBDashboard/ShowOceanShipping";
import { convertArray } from "../../../components/AWBDashboard/customFieldtConvert";

const defaultTheme = createTheme();

interface FieldData {
  id: string;
  autocompleteValue: OptionType | null;
  textValue: string | string[];
  value?: string | string[];
  required?: boolean;
  label?: string;
  isUnique?: boolean;
}

interface TagOption {
  value: string;
  label: string;
  color: string;
  description?: string;
}

interface ShippingLine {
  _id: string;
  liner: string;
  scacCode: string;
  abbreviation: string;
}

const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",
  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

function OceanTracklistPage() {
  const paginationModel = { page: 0, pageSize: 5 };
  const [shippingLines, setShippingLines] = useState<ShippingLine[]>([]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [oceanTrackingNum, setOceanTrackingNum] = useState("");
  const [trackingList, setTrackingList] = useState([]) as any;
  const [show, setShow] = useState(false);
  const [statusMessage, setStatusMessage] = useState({}) as any;
  const [errorList, setErrorList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [subscriptionFormData, setSubscriptionFormData] = useState<any>({
    whatsApp: [],
    emails: [],
    whatsAppMilestones: [],
    emailMilestones: [],
    milestoneList: [],
    mileStoneType: "",
    manageContactList: [],
    templateList: [],
    whatsappGroupList: [],
    whatsAppgroups: [],
    whatsappGroupMilestones: [],
    groupMilestone: "",
    flags: [],
    flagsList: [],
    contactOrganization: "",
  });
  const [modalPopup, setmodalPopup] = useState({
    subcriptionPopup: false,
    mileStonePopup: false,
    groupmilestoneModal: false,
    customfieldpopup: false,
  });
  const [options, setOptions] = React.useState<TagOption[]>([]);
  const [selectedOption, setSelectedOption] = React.useState<TagOption | null>(null);
  const [fields, setFields] = useState<any>([
    { id: "1", autocompleteValue: null, textValue: "" },
  ]);
  const [errors, setErrors] = useState<{
    [key: string]: { autocomplete: boolean; text: boolean };
  }>({});
  const [dataArray, setDataArray] = useState<FieldData[]>([]);
  const [allField, setAllField] = useState([]);
  const [subscriptiondata, setSubscriptionData] = useState([]);
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

  const { chargeRate, availableCredit, masterCustomFields } = useRole() as any;
  const { milestoneList, manageContactList } = subscriptionFormData;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  const getAllScac = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/ocean/shippingline");
      if (response.status === 200 && response.data.success) {
        setShippingLines(response.data.data);
      }
    } catch (err) { }
  };

  const getCustomForms = async () => {
    try {
      const { data } = await axiosInstance.get("/api/v1/custom-form/admin-fields");
      setAllField(data.data);
      setFields(data.data.map((item: any, i: number) => ({
        id: String(i + 1),
        autocompleteValue: {
          id: i + 1,
          label: item.fieldName,
          required: item.required,
          customFieldId: item._id,
          isUnique: item.isUnique,
        },
        textValue: "",
        label: item.fieldName,
        value: "",
        required: item.required,
        customFieldId: item._id,
        isUnique: item.isUnique,
      })));
    } catch (error: any) {
      throw error;
    }
  };

  const simpleOptions: any = allField.map((item: any, index: number) => ({
    id: index + 1,
    label: item.fieldName,
    required: item.required,
  }));

  const Fieldstype = allField.map((item: any, index: number) => {
    let f_type: string = "";
    switch (item.fieldType) {
      case "Text Box": f_type = "Textbox"; break;
      case "Dropdown List": f_type = "select"; break;
      case "Yes/No": f_type = "select"; break;
      case "Number": f_type = "Textbox"; break;
      case "Date": f_type = "Date"; break;
      default: f_type = "Textbox";
    }
    let fieldOptions: any[] = [];
    if (item.fieldType === "Dropdown List") {
      fieldOptions = (item.dropdownOptions as any[]).map((opt: any, idx: number) => ({
        id: idx + 1,
        label: opt,
      }));
    } else if (item.fieldType === "Yes/No") {
      fieldOptions = [{ id: 1, label: "Yes" }, { id: 2, label: "No" }];
    }
    return {
      id: index + 1,
      f_name: item.fieldName,
      f_type,
      default_value: "",
      is_required: item.required ? 1 : 0,
      options: fieldOptions,
    };
  });

  const fetchAllFlag = async () => {
    try {
      const { data } = await axiosInstance.get(`/api/v1/flags`);
      let finaldata = data.data
        .filter((flag: any) => flag.status === "Active")
        .map((flag: any) => {
          let flagId = flag.id;
          delete flag.id;
          return { ...flag, _id: flagId };
        });
      setSubscriptionFormData((prev: any) => ({ ...prev, flagsList: finaldata || [] }));
    } catch (error) {
      setSubscriptionFormData((prev: any) => ({ ...prev, flagsList: [] }));
    }
  };

  const isValidAWB = (awb: string) => {
    const regex = /^(BK|BL|CT)?[A-Z0-9]+(-[A-Z]{4})?$/;
    return regex.test(awb);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    let inputValue = event.target.value
      .replace(/[\r\n]+/g, ",")
      .replace(/\s*,\s*/g, ",")
      .replace(/\s+/g, ",")
      .replace(/[^A-Z0-9,-]/gi, "")
      .toUpperCase()
      .trim();

    const formattedValue = inputValue
      .split(",")
      .map((awb) => {
        awb = awb.trim();
        if (!awb) return "";
        if (!awb.includes("-") && awb.length > 7) {
          const mainPart = awb.slice(0, -4);
          const suffix = awb.slice(-4);
          if (/^[A-Z]{4}$/.test(suffix)) return `${mainPart}-${suffix}`;
        }
        return awb;
      })
      .filter((awb) => awb || awb === "")
      .join(",");

    setOceanTrackingNum(formattedValue);
  };

  // oceanTrackingNumber: null    → single null shipment (no tracking number yet)
  // oceanTrackingNumber: [...]   → normal array of tracking strings
  const buildOceanPayload = (trackingValue: string[] | null) => {
    const { whatsAppMilestones, emailMilestones, whatsappGroupMilestones } = subscriptionFormData;
    const whatsApps = subscriptionFormData.whatsApp?.map((item: any) => item.value);
    const emails = subscriptionFormData.emails?.map((item: any) => item.value);
    const whatsappGroups = subscriptionFormData.whatsAppgroups?.map((item: any) => item.value);
    const tagId = selectedOption?.value || null;
    const groupMilestone = subscriptionFormData.groupMilestone?.value || null;
    const flags = subscriptionFormData.flags.map((el: any) => el.value);
    const contactOrganization = subscriptionFormData?.contactOrganization?.value || "";
    const customerName = subscriptionFormData?.customerName?.item?.name || null;

    return {
      oceanTrackingNumber: trackingValue,
      whatsApps,
      emails,
      emailMilestones,
      whatsAppMilestones,
      whatsappGroups,
      whatsappGroupMilestones,
      tag: tagId,
      groupMilestone,
      flags,
      contactOrganization,
      customfields: convertArray(fields),
      customerName,
    };
  };

  const resetFields = () => {
    setOceanTrackingNum("");
    setSelectedOption(null);
    setSubscriptionFormData((prev:any)=>({
      ...prev,
      whatsApp: [], emails: [], whatsAppMilestones: [], emailMilestones: [],
      mileStoneType: "", whatsAppgroups: [], whatsappGroupMilestones: [],
      groupMilestone: { _id: "" }, flags: [],
      customerName: null,
    }));
    setFields(
      allField.map((item: any, i: number) => ({
        id: String(i + 1),
        autocompleteValue: {
          id: i + 1,
          label: item.fieldName,
          required: item.required,
          customFieldId: item._id,
          isUnique: item.isUnique,
        },
        textValue: "",
        label: item.fieldName,
        value: "",
        required: item.required,
        customFieldId: item._id,
        isUnique: item.isUnique,
      }))
    );
  };

  // ── Subscribe ──────────────────────────────────────────────────────────────
  // oceanTrackingNum === ""  →  null shipment: send oceanTrackingNumber: null
  //                             server validates that a unique custom field is present
  // oceanTrackingNum !== ""  →  normal array of tracking strings
  const handleSubscribe = async () => {
    const isNullMode = !oceanTrackingNum.trim();

    // For null mode: at least one isUnique custom field must have a value
    if (isNullMode) {
      const hasUniqueFilled = fields.some(
        (f: FieldData) => f.isUnique && f.value !== "" && f.value !== undefined
      );
      if (!hasUniqueFilled) {
        toast.error("Please fill at least one Unique custom field, or enter a tracking number.");
        return;
      }
    }

    try {
      const payload = isNullMode
        ? buildOceanPayload(null)                        // null shipment
        : buildOceanPayload(oceanTrackingNum.split(",")); // normal flow

      const response = await axiosInstance.post("/api/v1/ocean/add-ocean-number", payload);
      setSubscriptionData(response?.data?.data?.success);
      setStatusMessage(response?.data?.message);

      if (response.data.success) {
        setErrorList(
          response?.data?.data?.failed?.length > 0 ? response.data.data.failed : null
        );
        setShow(true);
        if (response?.data?.data?.failed?.length === 0) {
          resetFields();
        }
      }
    } catch (error: any) {
      setStatusMessage({});
      if (error?.response?.data?.error?.length > 0) {
        const errorlog = Array.isArray(error?.response?.data?.error)
          ? error?.response?.data?.error?.map((err: any) => ({ awb: "", reason: err?.message }))
          : [{ awb: "", reason: error?.response?.data?.error }];
        setErrorList(errorlog as any);
        setShow(true);
      }
    }
  };

  const handleOkClick = async () => {
    const newFieldErrors: Record<string, string> = {};
    for (const field of fields) {
      if (!field.required) continue;
      const isEmpty =
        field.value === "" ||
        field.value === undefined ||
        (Array.isArray(field.value) && field.value.length === 0);
      if (isEmpty) {
        newFieldErrors[field.id] = `${field.label} is required`;
      }
    }
    if (Object.keys(newFieldErrors).length > 0) {
      setFieldErrors(newFieldErrors);
      return;
    }

    const validFields: FieldData[] = fields.filter(
      (f: any) => f.autocompleteValue || f.textValue
    );
    setmodalPopup((prev) => ({ ...prev, customfieldpopup: false }));
    if (validFields.length === 0) return;
    setDataArray(validFields);
  };

  const getAllMileStone = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/ocean/ocean-milestone");
      setSubscriptionFormData((prev: any) => ({ ...prev, milestoneList: response?.data?.data }));
    } catch (err) { }
  };

  const whatsappGroup = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/whatsapp-group");
      setSubscriptionFormData((prev: any) => ({ ...prev, whatsappGroupList: response?.data?.data }));
    } catch (error) { }
  };

  const getAllTag = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/tag");
      const transformedOptions =
        response?.data?.data?.map((tag: any) => ({
          value: tag._id,
          label: tag.name,
          color: tag.colorCode,
          description: tag.description,
        })) || [];
      setOptions(transformedOptions);
    } catch (err: any) { }
  };

  React.useEffect(() => {
    getAllMileStone();
    whatsappGroup();
    getAllScac();
    fetchAllFlag();
    getAllTag();
    getCustomForms();
  }, []);

  const getTrackList = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        status
          ? `/api/v1/ocean/tracking-list?status=${status}`
          : "/api/v1/ocean/tracking-list"
      );
      setLoading(false);
      return response.data.data;
    } catch (err) {
      return [];
    }
  };

  useEffect(() => {
    async function fetchTrackListData() {
      const data = await getTrackList();
      setTrackingList(data);
    }
    fetchTrackListData();
  }, [show, status]);

  const handleRedirect = () => navigate("/oceancsvbulkupload");

  const formatDate: (dateString: string | number | Date) => string = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const columns: GridColDef[] = [
    { field: "index", headerName: "S.No.", disableColumnMenu: true, width: 70 },
    { field: "shippingLine", headerName: "Shipping Line", width: 200 },
    { field: "addedByName", headerName: "Addded By", width: 150 },
    { field: "oceanTrackingNumber", headerName: "Tracking Number", width: 200 },
    {
      field: "createdAt",
      headerName: "Added Date",
      width: 150,
      filterOperators: [
        {
          label: "On",
          value: "equals",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) return null;
            return (params) => {
              if (!params) return false;
              return formatDate(params) === formatDate(filterItem.value);
            };
          },
          InputComponent: ({ item, applyValue }) => (
            <div style={{ padding: "8px" }}>
              <input
                type="date"
                onChange={(e) => applyValue({ ...item, value: e.target.value })}
                value={item.value || ""}
              />
            </div>
          ),
        },
      ],
      renderCell: (params: any) => formatDate(params?.row?.createdAt),
    },
    { field: "placeOfReceipt", headerName: "Origin", width: 150 },
    { field: "placeOfDelivery", headerName: "Destination", width: 200 },
    { field: "currentStatus", headerName: "Status", width: 150 },
    {
      field: "MILDSTONE",
      headerName: "Mildstone",
      width: 140,
      disableColumnMenu: true,
      renderHeader: () => <Box display="flex" alignItems="center">Milestone</Box>,
      renderCell: (params: any) => {
        const trackingStatus =
          params?.row?.currentStatus === "Pending" ||
          !params?.row?.currentStatus ||
          params?.row?.currentStatus === "" ||
          params?.row?.currentStatus === "InActive";
        return (
          <Tooltip
            sx={{ cursor: trackingStatus ? "pointer" : "default" }}
            title={trackingStatus ? "No Status Available" : null}
          >
            <IconButton>
              <RemoveRedEyeOutlinedIcon
                sx={{ pointerEvents: trackingStatus ? "none" : "" }}
                style={{ cursor: "pointer" }}
                onClick={() => handleIconClick(params.row)}
              />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const handleIconClick = (row: any) => {
    navigate(`/oceanTrackingDetail?trackingId=${row?.oceanTrackingNumber}`);
  };

  const isLowBalance = availableCredit <= 0 || availableCredit < chargeRate.containerRate;

  // hint shown below the text field when no tracking number is entered
  const isNullMode = !oceanTrackingNum.trim();

  return (
    <>
      <div className="old_dashboard_title">
        <h1 className="text-2xl font-bold text-gray-700 mt-[-15px] mb-[10px]">
          Manage Ocean Tracking
        </h1>
      </div>
      <ThemeProvider theme={defaultTheme}>
        <div className="whiteBoxnew mb-6">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-12">
              <div className="awbtextBox">
                <TextField
                  className="awbinputttt"
                  required
                  id="outlined-basic"
                  label={
                    <Typography>
                      Add Bill of Lading number, Booking number, or Container
                      number along with shipping line's SCAC code <br /> like
                      BLXXXXXXXXX-MSCU. Use prefix BL for Bill of Lading, BK for
                      Booking number, and CT for Container Number. *
                    </Typography>
                  }
                  variant="outlined"
                  value={oceanTrackingNum}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  minRows={3}
                  disabled={isLowBalance}
                />
                {isLowBalance && (
                  <Typography variant="body2" color="error" sx={{ mt: 1, fontWeight: 500 }}>
                    Your account balance is low. Please add money to your account to
                    continue adding new tracking numbers.
                  </Typography>
                )}
                {/* hint when textarea is empty */}
                {isNullMode && !isLowBalance && (
                  <Typography variant="body2" sx={{ mt: 0.5, color: "#888", fontSize: 12 }}>
                    No tracking number? Fill a <strong>Unique</strong> custom field and click Subscribe.
                  </Typography>
                )}
              </div>

              <div className="awbBtnBox mt-1">
                <div className="text-right">
                  <button
                    onClick={handleOpen}
                    className="text-blue-700 text-sm hover:underline hover:text-yellow-500"
                  >
                    Check list of available shipping lines
                  </button>
                </div>
              </div>

              <OceanShippingShowModal
                open={open}
                handleClose={handleClose}
                shippingLines={shippingLines}
              />
            </div>

            <div className="col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <div className="uploadbtn ml-0 lg:ml-10 md:ml-10 sm:ml-0">
                <h3 className="font-bold text-lg">Upload</h3>
                <p className="text-base text-gray-500 mb-2">File format: CSV only</p>
                <button onClick={handleRedirect} className="btn btnTheme px-6 py-2">
                  <FileUploadIcon className="btn btnTheme" />
                  Upload
                </button>
              </div>
            </div>

            <div className="col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
              <div className="w-full">
                <Button
                  variant="contained"
                  className="btn btnTheme ml3 mt-3 mb-3"
                  onClick={() =>
                    setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true }))
                  }
                >
                  {subscriptionFormData?.whatsAppMilestones?.length > 0 ||
                    subscriptionFormData.emailMilestones?.length > 0
                    ? `whatsApp ${subscriptionFormData?.whatsAppMilestones?.length} emails ${subscriptionFormData?.emailMilestones?.length} whatsappGroups ${subscriptionFormData?.whatsappGroupMilestones?.length}`
                    : "Manage Channels"}
                  <EditIcon sx={{ marginLeft: "10px" }} />
                </Button>
                <Button
                  variant="contained"
                  className="btn btnTheme ml3 mt-3"
                  onClick={() =>
                    setmodalPopup((prev) => ({ ...prev, groupmilestoneModal: true }))
                  }
                >
                  {(subscriptionFormData?.groupMilestone?.value || "").length > 0
                    ? `${subscriptionFormData?.groupMilestone?.item?.groupName || ""}`
                    : "Add Milestone Grouping"}
                </Button>
                <Button
                  variant="contained"
                  className="btn btnTheme ml3 mt-3"
                  onClick={() => setmodalPopup(p => ({ ...p, customfieldpopup: true }))}
                >
                  {convertArray(fields).length > 0
                    ? "✓ Custom field selected"
                    : isNullMode
                      ? "⚠ Add Unique custom field"
                      : "Add custom field values"}
                </Button>
                <Button
                  variant="contained"
                  className="btn btnTheme btnGray mb-3"
                  onClick={handleSubscribe}
                >
                  Subscribe
                </Button>
              </div>
            </div>
          </div>
        </div>

        {trackingList?.length >= 0 && (
          <div className="whiteBox relative">
            <Paper sx={{ height: 430, width: "100%" }}>
              {loading ? (
                <Loading />
              ) : (
                trackingList?.length >= 0 && (
                  <DataGrid
                    rows={trackingList.map((item: any, index: number) => ({
                      ...item,
                      index: index + 1,
                      currentStatus: item?.currentStatus?.milestone,
                      addedByName: item?.customerId?.name,
                    }))}
                    columns={columns}
                    getRowId={(row) => row._id}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    sx={{ border: 0 }}
                  />
                )
              )}
            </Paper>
          </div>
        )}

        {error && (
          <Box mt={3} sx={{ color: "red", marginLeft: "30px" }}>
            {error}
          </Box>
        )}
      </ThemeProvider>

      <DialogBox
        open={show}
        successMessage={
          <DialogTitle>
            <Typography
              variant="h6"
              className={`font-semibold ${statusMessage?.messageStatus === 1 ? "text-green-500" : "text-red-500"}`}
            >
              {statusMessage?.message}
            </Typography>
          </DialogTitle>
        }
        handleClose={() => { setShow(false); setErrorList(null); }}
        data={errorList}
      />

      <ModalPopup
        open={modalPopup.subcriptionPopup || modalPopup.mileStonePopup}
        handleClose={() =>
          setmodalPopup((prev) => ({ ...prev, subcriptionPopup: false, mileStonePopup: false }))
        }
        heading={""}
      >
        {modalPopup.subcriptionPopup ? (
          <SubscriptionForm
            editData={{}}
            subscriptionFormData={subscriptionFormData}
            manageContactList={manageContactList}
            setmodalPopup={setmodalPopup}
            setSubscriptionFormData={setSubscriptionFormData}
            whatsappGroupList={subscriptionFormData.whatsappGroupList}
          />
        ) : (
          <Milestone
            subscriptionFormData={subscriptionFormData}
            milestoneList={milestoneList}
            setSubscriptionFormData={setSubscriptionFormData}
            onclose={() =>
              setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true, mileStonePopup: false }))
            }
          />
        )}
      </ModalPopup>

      <ModalPopup
        open={modalPopup.groupmilestoneModal}
        handleClose={() =>
          setmodalPopup((prev) => ({ ...prev, groupmilestoneModal: false }))
        }
        heading={""}
      >
        {modalPopup.groupmilestoneModal && (
          <AddMilestoneGroupingForm
            editData={{}}
            subscriptionFormData={subscriptionFormData}
            type="ocean"
            setmodalPopup={setmodalPopup}
            setSubscriptionFormData={setSubscriptionFormData}
          />
        )}
      </ModalPopup>

      <ModalPopup
        open={modalPopup.customfieldpopup}
        handleClose={() => {
          setmodalPopup((prev) => ({ ...prev, customfieldpopup: false }));
          setFieldErrors({});
        }}
        heading={"Manage Custom Fields"}
      >
        {modalPopup.customfieldpopup && (
          <div className="flex flex-col">
            <AddcustomfieldsForm
              simpleOptions={simpleOptions}
              Fieldstype={Fieldstype}
              setmodalPopup={setmodalPopup}
              fields={fields}
              setFields={setFields}
              errors={errors}
              setErrors={setErrors}
              setDataArray={setDataArray}
              fieldErrors={fieldErrors}
              setFieldErrors={setFieldErrors}
              subscriptionFormData={subscriptionFormData}
              setSubscriptionFormData={setSubscriptionFormData}
            />
            <div className="modalInnerFieldFooter flex justify-end">
              <button className="btnTheme btnPadding" onClick={handleOkClick}>
                OK
              </button>
            </div>
          </div>
        )}
      </ModalPopup>
    </>
  );
}

export default OceanTracklistPage;